import { gql } from '@apollo/client';

export const GET_STATISTICS = gql`
  query getStatistics {
    getStatistics {
      students
      teachers
      cohorts
      subjects
    }
  }
`;

/** The caller's own counts — the argument the old query took is gone. */
export const GET_INSTRUCTOR_STATISTICS = gql`
  query getInstructorStatistics {
    getInstructorStatistics {
      students
      cohorts
      subjects
    }
  }
`;
